// Time-of-day maths shared by the schedule and attendance grids.
//
// Times are 'HH:MM' strings (the API's TIME columns, trimmed); arithmetic is
// done in minutes since midnight. Pure — no dates, no time zones.

/** 'HH:MM' → minutes since midnight. */
export function timeToMins(t: string): number {
  const [h, m] = t.split(':').map(Number);
  return h * 60 + m;
}

/** Minutes since midnight → 'HH:MM'. */
export function minsToTime(mins: number): string {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

/** Two [start,end) minute ranges overlap iff each starts before the other ends. */
export function timeRangesOverlap(aStart: number, aEnd: number, bStart: number, bEnd: number): boolean {
  return aStart < bEnd && bStart < aEnd;
}

/** One column of a day grid. */
export interface Slot {
  start: string;
  end: string;
  hourStart: boolean;
}

/** The grid's columns from startTime to endTime, slotMinutes wide; the last
 *  one is cut short if the day doesn't divide evenly. */
export function buildSlots(slotMinutes: number, startTime: string, endTime: string): Slot[] {
  const slots: Slot[] = [];
  let mins = timeToMins(startTime);
  const end = timeToMins(endTime);
  while (mins < end) {
    const endMins = Math.min(mins + slotMinutes, end);
    slots.push({
      start: minsToTime(mins),
      end: minsToTime(endMins),
      hourStart: mins % 60 === 0,
    });
    mins = endMins;
  }
  return slots;
}
